export default "__VITE_ASSET__DWe5DJAV__"